import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import NavBar from '../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { Base_Url, fetchOffers, deleteOffer } from '../../config/config';
import ViewOffer from '../../component/b2c/models/viewAllOfferModel';

const AllOffers = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [offers, setOffers] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [loadingOfferId, setLoadingOfferId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchOffersData();
    }, [page, limit]);

    const fetchOffersData = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlOffers = `${Base_Url}${fetchOffers}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlOffers, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cusid,
                    'Content-Type': 'application/json'
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS" && Array.isArray(result.data)) {
                setOffers(result.data);
                setTotalOrders(result.pagination.totalItems || 0);
            } else {
                console.error('Unexpected response format:', result);
            }
        } catch (error) {
            console.error('Error fetching offers data:', error);
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
        setCurrentPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
        setCurrentPage(1);
    };

    const handleViewClick = (offer) => {
        setSelectedOffer(offer);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    const handleDelete = (id) => {
        setLoadingOfferId(id);
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this deletion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#000000',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const urldelete = Base_Url + deleteOffer + "/" + id;
                const token = localStorage.getItem('token');
                const cusid = localStorage.getItem('cus_id');

                fetch(urldelete, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "token": token,
                        "cus_id": cusid,
                    },
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.status === "SUCCESS") {
                            setOffers((prevOffers) => prevOffers.filter((offer) => offer.id !== id));
                            setTotalOrders((prev) => prev - 1);

                            Swal.fire(
                                'Deleted!',
                                data.message || 'Offer has been deleted successfully.',
                                'success'
                            );
                        } else {
                            Swal.fire(
                                'Error!',
                                'Unexpected response format: ' + data.message,
                                'error'
                            );
                        }
                    })
                    .catch((error) => {
                        Swal.fire(
                            'Error!',
                            'Error deleting offer: ' + error.message,
                            'error'
                        );
                    })
                    .finally(() => {
                        setLoadingOfferId(null);
                    });
            } else {
                setLoadingOfferId(null);
            }
        });
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const getFilteredOffers = () => {
        if (!searchTerm.trim()) {
            return offers;
        }

        const term = searchTerm.toLowerCase();
        return offers.filter(offer => {
            return (
                (offer.id?.toString().toLowerCase().includes(term)) ||
                (offer.coupon_code?.toLowerCase().includes(term)) ||
                (offer.category?.toLowerCase().includes(term)) ||
                (offer.discount_type?.toLowerCase().includes(term))
            );
        });
    };

    const displayOffers = getFilteredOffers();
const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
                  <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
          
                      <NavBar />
                      <div className="flex flex-1 overflow-hidden">
                          {isToggleSidebar && (
                              <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                                  <Sidebar />
                              </div>
                          )}

        <div className="flex-1 p-3 bg-gray-200 dark:bg-darkmodeColor overflow-hidden">

                        <button
                            // onClick={handleNavigation}
                            className="w-full text-sm font-semibold mb-4 bg-emerald-600 hover:opacity-80 text-white px-4 py-2.5 rounded flex items-center justify-center transition-all shrink-0">
                            <LuWarehouse className="mr-2" size={16} />
                            All Offers
                        </button>

                        <div className="mb-4 shrink-0">
                            <div className="relative flex items-center bg-white dark:bg-black border border-gray-300 dark:border-gray-700 rounded focus-within:border-black dark:focus-within:border-white transition-colors">
                                <div className="pl-3 pr-2">
                                    <CgSearch color='blue' className="text-gray-400" size={16} />
                                </div>

                                <input
                                    type="text"
                                    placeholder="Search by Id / Coupon Code / Category / Discount Type"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    className="flex-1 py-2.5 bg-transparent outline-none dark:text-white text-black placeholder-gray-400 text-xs"
                                />

                                {searchTerm && (
                                    <button
                                        onClick={() => handleSearchChange({ target: { value: '' } })}
                                        className="mr-3 p-1 text-gray-400 hover:text-black dark:hover:text-white transition-colors rounded-full"
                                    >
                                        <span className="sr-only">Clear search</span>
                                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto overflow-x-auto border border-gray-200 dark:border-gray-800 rounded">
                            <table className="min-w-full table-auto">
                                <thead className="bg-blue-600 text-white text-[10px] uppercase tracking-wide sticky top-0 z-10">
                                    <tr>
                                        <th className='p-2 text-left font-medium'>Offer ID</th>
                                        <th className='p-2 text-left font-medium'>Coupon Code</th>
                                        <th className='p-2 text-left font-medium'>Category</th>
                                        <th className='p-2 text-left font-medium'>Discount Type</th>
                                        <th className='p-2 text-left font-medium'>Discount Value</th>
                                        <th className='p-2 text-left font-medium'>Start Date</th>
                                        <th className='p-2 text-left font-medium'>End Date</th>
                                        <th className='p-2 text-left font-medium'>Status</th>
                                        <th className='p-2 text-left font-medium'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className=" dark:divide-gray-800 dark:bg-black">
                                    {displayOffers.map((offer, index) => (
                                        <tr
                                            key={offer.id}
                                            className="hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors duration-150 bg-white dark:bg-black"
                                        >
                                            <td className='p-2 text-xs text-black dark:text-white cursor-pointer hover:underline font-medium'>
                                                {offer.id}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>{offer.coupon_code}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>{offer.category}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>{offer.discount_type}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-mono'>
                                                {offer.discount_type === 'Percentage' ? `${offer.discount_value}%` : `₹${offer.discount_value}`}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>{offer.start_date}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>{offer.end_date}</td>
                                            <td className='p-2'>
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium border ${offer.status === 'Active'
                                                    ? 'border-black text-black dark:border-white dark:text-white'
                                                    : offer.status === 'Scheduled'
                                                        ? 'border-gray-400 text-gray-600 dark:text-gray-300'
                                                        : offer.status === 'Expired'
                                                            ? 'border-gray-300 text-gray-400'
                                                            : 'border-gray-200 text-gray-500'
                                                    }`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${offer.status === 'Active'
                                                        ? 'bg-black dark:bg-white'
                                                        : 'bg-gray-400'
                                                        }`}></span>
                                                    {offer.status || 'Active'}
                                                </span>
                                            </td>
                                            <td className='p-2'>
                                                <div className='flex items-center gap-1.5'>
                                                    <Button
                                                        onClick={() => handleViewClick(offer)}
                                                        variant="outlined"
                                                        size="small"
                                                        className="min-w-0 p-1 rounded"
                                                        // style={{
                                                        //     borderColor: '#000',
                                                        //     color: '#000',
                                                        // }}
                                                    >
                                                        <IoMdEye color='blue' className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleDelete(offer.id)}
                                                        variant="contained"
                                                        size="small"
                                                        disabled={loadingOfferId === offer.id}
                                                        className="min-w-0 p-1 rounded"
                                                        style={{
                                                            backgroundColor: loadingOfferId === offer.id ? '#e5e7eb' : 'white',
                                                            color: loadingOfferId === offer.id ? '#6b7280' : '#fff',
                                                        }}
                                                    >
                                                        {loadingOfferId === offer.id ? (
                                                            <span className="animate-spin">⏳</span>
                                                        ) : (
                                                            <MdDelete color='red' className="text-xs" />
                                                        )}
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 flex flex-col sm:flex-row justify-between items-center gap-2 shrink-0">
                            <span className="text-xs text-black dark:text-gray-300 font-medium">{`Total Offers: ${totalOrders}`}</span>
                            <select
                                id="limit"
                                value={limit}
                                onChange={handleLimitChange}
                                className={`border border-gray-300 dark:border-gray-700 rounded p-1 text-xs bg-white dark:bg-black dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-50' : ''}`}
                                disabled={totalOrders < 10}
                            >
                                {totalOrders === 0 ? (
                                    <option value={0}>0</option>
                                ) : (
                                    <>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={totalOrders}>All</option>
                                    </>
                                )}
                            </select>

                            <Pagination
                                count={Math.ceil(totalOrders / limit)}
                                page={currentPage}
                                onChange={handlePaginationChange}
                                variant="outlined"
                                shape="rounded"
                                className="pagination"
                                size="small"
                                renderItem={(item) => (
                                    <PaginationItem
                                        {...item}
                                        style={{
                                            backgroundColor: item.selected ? '#000' : 'transparent',
                                            color: item.selected ? '#fff' : '#000',
                                            borderColor: '#000',
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>

                <ViewOffer isopen={isPopupOpen} onClose={handleClose} offer={selectedOffer} />
            </div>
        </>
    );
};

export default AllOffers;